import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import {
  DoppiaMaterialitaService,
  DoppiaSurvey,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { DialogAssegnaCategoriaIroComponent } from './dialog-assegna-categoria-iro/dialog-assegna-categoria-iro.component';
import { MatDialog } from '@angular/material/dialog';
import { TooltipVariabiliIroComponent } from '../dialog/dialog-crea-doppia-materialita/tooltip-variabili-iro/tooltip-variabili-iro.component';

@Component({
  selector: 'app-assegnazione-iro',
  standalone: false,

  templateUrl: './assegnazione-iro.component.html',
  styleUrl: './assegnazione-iro.component.scss',
})
export class AssegnazioneIroComponent implements AfterViewInit {
  @ViewChild(TooltipVariabiliIroComponent) cmpTooltipVatiableIro!: TooltipVariabiliIroComponent;

  public etichetteESRS: { [idTema: string]: string } | undefined = {};

  private _doppiaSurvey: DoppiaSurvey | undefined;
  @Input()
  set doppiaSurvey(doppiaSurvey: DoppiaSurvey | undefined) {
    this._doppiaSurvey = doppiaSurvey;
    this.etichetteESRS = this._doppiaMaterialitaService.creaEtichettaESRS(this._doppiaSurvey);
  }
  get doppiaSurvey(): DoppiaSurvey | undefined {
    return this._doppiaSurvey;
  }

  public _tipoIRO: 'rischi' | 'opportunita' | 'impattiIro' | undefined = undefined;
  @Input()
  set tipoIRO(tipoIRO: 'rischi' | 'opportunita' | 'impattiIro' | undefined) {
    this._tipoIRO = tipoIRO;
  }
  get tipoIRO() {
    return this._tipoIRO;
  }

  public _isTabCriteri: boolean = false;
  @Input()
  set isTabCriteri(isTabCriteri: boolean) {
    this._isTabCriteri = isTabCriteri;
  }
  get isTabCriteri() {
    return this._isTabCriteri;
  }

  private _isPermessoSoloRead = false;
  @Input()
  set isPermessoSoloRead(isPermessoSoloRead: boolean) {
    this._isPermessoSoloRead = isPermessoSoloRead;
  }
  get isPermessoSoloRead() {
    return this._isPermessoSoloRead;
  }

  private _arrayIdElementiAssegnati: string[] = [];
  @Input()
  set arrayIdElementiAssegnati(arrayIdElementiAssegnati: string[]) {
    this._arrayIdElementiAssegnati = arrayIdElementiAssegnati;
  }
  get arrayIdElementiAssegnati() {
    return this._arrayIdElementiAssegnati;
  }

  public mappaTipoIro = { impattiIro: 'Impatto', rischi: 'Rischio', opportunita: 'Opportunità' };

  ngAfterViewInit(): void {}

  constructor(
    public dialog: MatDialog,
    private readonly _doppiaMaterialitaService: DoppiaMaterialitaService,
  ) {}

  assegnaStakeholders(idAmbito: string, idTematica: string, idTema: string | null, idIro: string) {
    let iroType;

    if (this._tipoIRO === 'impattiIro') {
      iroType = 'impatti';
    } else {
      iroType = this._tipoIRO;
    }

    const dialogAssegnaCategoriaIro = this.dialog.open(DialogAssegnaCategoriaIroComponent, {
      data: {
        idDoppiaMaterialita: this._doppiaSurvey?.materialita[0],
        idAmbito,
        idTematica,
        idTema,
        idIro: idIro,
        iroType: iroType,
        disabled: this.doppiaSurvey?.stato === 'PUBBLICATO' || this.isPermessoSoloRead,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '70%',
      height: '75%',
      autoFocus: false,
    });

    dialogAssegnaCategoriaIro.afterClosed().subscribe((result) => {
      if (result) {
        const id = idAmbito + '_' + idTematica + '_' + (idTema ? idTema + '_' + idIro : idIro);
        if (!this.arrayIdElementiAssegnati.includes(id)) {
          this.arrayIdElementiAssegnati.push(id);
        }
      }
    });
  }

  isElementoAssegnato(idAmbito: string, idTematica: string, idTema: string | null, idIro: string) {
    const id = idAmbito + '_' + idTematica + '_' + (idTema ? idTema + '_' + idIro : idIro);

    if (this._arrayIdElementiAssegnati.includes(id)) {
      return true;
    }

    return false;
  }

  normalizzaTipoIro(tipoIro: string | undefined) {
    switch (tipoIro) {
      case 'impattiIro':
        return 'impatto';

      case 'rischi':
        return 'rischio';

      case 'opportunita':
        return 'opportunita';

      default:
        break;
    }

    return '';
  }

  haVariabili(iro: any): boolean {
    if (!iro) return false;

    // helper function
    const hasValue = (v: unknown): boolean => {
      if (v === null || v === undefined) return false;
      if (typeof v === 'string') return v.trim().length > 0;
      if (Array.isArray(v)) return v.length > 0;
      if (typeof v === 'object') return Object.keys(v).length > 0;
      return true; // numeri, booleani
    };

    return [
      iro.impattoPotenzialeEffettivo,
      iro.impattoPositivoNegativo,
      iro.impattoDirettoIndiretto,
      iro.fonte,
      iro.catene,
      iro.orizzontiTemporali,
    ].some(hasValue);
  }
}
